module.exports = __webpack_public_path__ + "static/media/loader.e84c4469.svg";